export default __webpack_public_path__ + "static/media/img-0221-netherlands-full-face.2c73dba8.png";